import CloseIcon from '@mui/icons-material/Close';

import { Box, ButtonBase, ConfirmRemoveButton, Typography } from '@/shared/ui';
import EllipsisWithTooltip from '@/shared/ui/primitives/EllipsisWithTooltip';

import type { SavedFilter, SavedFilterCriteria } from '@/entities/saved-filter';
import { getTimeSince } from '@/shared/lib/date/getTimeSince';

const rowSx = {
  display: 'flex',
  px: 1.5,
  alignItems: 'center',
  gap: 1,
  width: '100%',
  height: 32,
  borderBottom: '0.5px solid',
  borderBottomColor: 'gx.response',
  '&:hover .saved-filter-delete, &:focus-within .saved-filter-delete': {
    width: 24
  }
};

const applyButtonSx = {
  flex: 1,
  minWidth: 0,
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  justifyContent: 'flex-start'
};

const nameSx = { flex: 1, minWidth: 0, fontSize: 14, color: '#C2C2C2', textAlign: 'left' };
const timeSx = { flexShrink: 0, fontSize: 9, color: 'gx.border' };
const deleteButtonSx = {
  width: 0,
  minWidth: 0,
  height: 24,
  p: 0,
  overflow: 'hidden',
  transition: 'width 0.15s ease',
  color: 'gx.border',
  fontSize: 12,
  backgroundColor: 'transparent',
  '&:hover': { backgroundColor: 'transparent', opacity: 1 }
};

interface SavedFilterRowProps {
  filter: SavedFilter;
  onApply: (criteria: SavedFilterCriteria) => void;
  onDelete: (id: string) => void;
}

const SavedFilterRow = ({ filter, onApply, onDelete }: SavedFilterRowProps) => (
  <Box sx={rowSx}>
    <ButtonBase
      sx={applyButtonSx}
      onClick={() => {
        onApply(filter.criteria);
      }}
    >
      <Box sx={nameSx}>
        <EllipsisWithTooltip text={filter.name} />
      </Box>
      <Typography sx={timeSx}>{getTimeSince(filter.createdAt)}</Typography>
    </ButtonBase>
    <ConfirmRemoveButton
      ariaLabel='Delete saved filter'
      className='saved-filter-delete'
      description={`"${filter.name}" will be permanently deleted.`}
      icon={<CloseIcon sx={{ fontSize: 12 }} />}
      title='Delete saved filter?'
      triggerSx={deleteButtonSx}
      onConfirm={() => {
        onDelete(filter.id);
      }}
    />
  </Box>
);

export default SavedFilterRow;
